import { styled } from '../theme';
import Small from './Small';

const FieldLabel = styled(Small.withComponent('label'))(({ theme }) => ({
    ...theme.typography.textStyles.label,
    color: theme.color.gray70,
    marginBottom: 0,
    opacity: 0.4,
}));

export default FieldLabel;
